import GameBookBtn from '../gameBookBtn';
import GameBook from '../gameBook';
import OpenGameBook from '../OpenGameBook';
import { GameBookType } from '@/_models/game/GameBook';

export const GameBookHandle = ({ gameBook, showBook, onToggleGameBookModal, closeGameBook, hideBook, unlockedChapterIds, moveToSweep, tryButtonPlaySound }: any) => {
  return (
    <>
      <GameBookBtn onToggle={onToggleGameBookModal} hide={hideBook} />
      {gameBook?.type === GameBookType.Close && showBook && (
        <GameBook
          show={showBook}
          onClose={closeGameBook}
          book={gameBook}
          unlockedChapterIds={unlockedChapterIds}
          tryButtonPlaySound={tryButtonPlaySound}
          moveToSweep={(sweepUuid) => {
            moveToSweep(sweepUuid);
            closeGameBook();
          }}
        />
      )}
      {gameBook?.type === GameBookType.Open && showBook && (
        <OpenGameBook show={showBook} onClose={closeGameBook} book={gameBook} unlockedChapterIds={unlockedChapterIds} moveToSweep={moveToSweep} />
      )}
    </>
  );
};
